module.exports = __webpack_public_path__ + "static/media/overpass-extralight-italic.07d68df8.ttf";